import script from "./PageContentBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageContentBase.vue?vue&type=script&lang=ts&setup=true"

import "./PageContentBase.vue?vue&type=style&index=0&id=a579754c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a579754c"]])

export default __exports__